/** MUI `sx` dizisi — nested objeler deep-merge olur, spread gibi ezilmez */
export function toSxArray(...parts) {
  return parts
    .flat(Infinity)
    .filter((part) => part != null && part !== false);
}
